module.exports = __webpack_public_path__ + "/jpg/logo.d69ba3e5930ab75de3cb8a27c3587588.jpg";